module.exports = __webpack_public_path__ + "static/img/A159.219db5a9.jpg";